import { TypedTypePolicies } from '@/lib/apollo/cache/gen/helpers';

export const typePolicies: TypedTypePolicies = {
  User: {
    keyFields: ['userId'],
  },
  BankAccount: {
    keyFields: ['accountHolder'],
  },
  PersonalInfo: {
    keyFields: ['lastName', 'firstName'], // これを ID の代わりとして試す
  },
};
